import { http, isStatus } from "./http";

export type Impersonator = { id: string; userName: string };

export type SessionUser = {
    id: string;
    userName: string;
    isAuthenticated: boolean;
    isAdmin: boolean;
    preferredTheme: string | null;
    impersonator: Impersonator | null;
};

export type StoppedImpersonation = { impersonatedId: string; signedIn: boolean };

export type ThemeChoice = "system" | "light" | "dark";

export const authApi = {
    async login(email: string, password: string, rememberMe: boolean): Promise<boolean> {
        try {
            await http.post("/api/v0/authentication/login", { email, password, rememberMe });
            return true;
        } catch (error) {
            if (isStatus(error, 401)) return false;
            throw error;
        }
    },
    async logout(): Promise<void> {
        await http.post("/api/v0/authentication/logout");
    },
    async setTheme(theme: ThemeChoice): Promise<void> {
        await http.put("/api/v0/users/me/theme", { theme });
    },
    async stopImpersonating(): Promise<StoppedImpersonation> {
        const { data } = await http.post<StoppedImpersonation>("/api/v0/users/me/stop-impersonating");
        return data;
    },
    async changePassword(currentPassword: string, newPassword: string): Promise<void> {
        await http.post("/api/v0/users/me/password", { currentPassword, newPassword });
    },
    async me(): Promise<SessionUser | null> {
        try {
            const { data } = await http.get<SessionUser>("/api/v0/users/me");
            return data;
        } catch (error) {
            if (isStatus(error, 401)) return null;
            throw error;
        }
    },
};
